"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getErrorByType = function (errors, type) {
    if (!errors.length) {
        return;
    }
    return errors.find(function (error) { return error && error.error === type; });
};
exports.default = getErrorByType;
//# sourceMappingURL=get-error-by-type.js.map